// utils/getApiForRole.js

import { Api } from "../../../api";
import { CompanyApi } from "../../../api/companyApi";
import { isSuperAdmin, isCopanySuperOrSubAdmin, isSuperAndSubAdmin } from "../../../utils/helper";

export const ApiForRole = () => {
  // if (isSuperAdmin()) return Api;
  if (isCopanySuperOrSubAdmin()) return CompanyApi;
  if(isSuperAndSubAdmin()) return Api;
  throw new Error("Invalid user type");
};
